import React from 'react';

import { QBox, QText } from '@captivateiq/quotient';

interface ThinkingCompleteProps {
  elapsedSeconds: number;
}

export const ThinkingComplete = ({ elapsedSeconds }: ThinkingCompleteProps) => {
  return (
    <QBox>
      <QText sx={{ color: 'text.onSurface.background.mediumContrast', fontStyle: 'italic' }} variant="smallRegular">
        Thought for{' '}
        <QText component="span" variant="smallSemiBold">
          {elapsedSeconds}s
        </QText>
      </QText>
    </QBox>
  );
};
